import {
    commonTH
} from "./common";
import {
    adminTH
} from "./element/admin";
import {
    footerTH,
    loginTH
} from "./element/login";
import {
    notfoundTH
} from "./element/notFound";
import {
    formHeaderTH
} from "./element/otherComponent";
import {
    docTH,
    formSummitTH,
    formTH,
    step2TH,
    step3TH,
    step4TH,
    step5TH,
    stepperBarTH
} from "./element/step";
import {
    registrationFormTH
} from "./registerForm";
import { applicationIDcardTH } from "./element/applicationIDcard";
import { qualifiedApplicantsTH } from "./element/qualifiedApplicants";
import { conditionTH } from "./element/conditionTermPage";
import { policyTH } from "./element/policyPage";

export const th = {
    message: {
        adminPage: adminTH,
        loginPage: loginTH,
        notFoundPage: notfoundTH,
        footer: footerTH,
        form: formTH,
        step2: step2TH,
        step3: step3TH,
        step4: step4TH,
        step5: step5TH,
        formSummit: formSummitTH,
        doc: docTH,
        formHeader: formHeaderTH,
        stepperBar: stepperBarTH,
        common: commonTH,
        registration_form: registrationFormTH,
        applicationIDcard: applicationIDcardTH,
        qualifiedApplicants:qualifiedApplicantsTH, 

        conditionTermPage: conditionTH,
        policyPage: policyTH
    }
}
